export enum AddressField {
  postCode = 'postCode',
  city = 'city',
  address = 'address',
  name = 'name',
}

export type AddressDirection = 'loading' | 'unloading';
